export const CAMERA_GESTURE = {
  NONE: 'none',
  PAN: 'pan',
  PINCH: 'pinch',
};

/**
 * Какой жест камеры сейчас идет: панорамирование или pinch-зум.
 *
 * Решение принимается по ДВУМ величинам, потому что ни одной по отдельности
 * доверять нельзя:
 *  - trackedPointerCount — сколько указателей считает зажатыми Phaser (и наш
 *    учет поверх него). Значение «залипает»: мобильные браузеры теряют
 *    завершающие touch-события (системный свайп, шторка, long-press callout,
 *    сворачивание вкладки), и указатель навсегда остается isDown. Пул
 *    указателей под касания всего два (activePointers: 2 в HexGrid), так что
 *    одного фантома достаточно, чтобы КАЖДЫЙ следующий пан выглядел как pinch —
 *    поле зумилось вместо перемещения до перезагрузки страницы;
 *  - nativeTouchCount — длина event.touches последнего нативного touch-события,
 *    то есть сколько пальцев на экране по мнению самого браузера. Это истина
 *    про пальцы, но она ничего не знает о мыши (там всегда 0) и считает пальцы
 *    по всей странице, а не только по канве (палец на кнопке интерфейса, пока
 *    второй тянет поле, — обычное дело).
 *
 * Отсюда правила:
 *  - pinch только если ОБА источника согласны, что пальцев два: фантом
 *    (указателей 2, пальцев 1) больше не превращает пан в зум;
 *  - пан — если Phaser видит ровно один указатель ИЛИ браузер видит ровно один
 *    палец. Второе условие вытаскивает жест из залипшего состояния, первое
 *    сохраняет привычное поведение, когда лишний палец лежит на интерфейсе.
 *
 * @param {number} trackedPointerCount - зажатых указателей по учету сцены
 * @param {number} nativeTouchCount - пальцев на экране по данным браузера
 * @returns {string} значение CAMERA_GESTURE
 */
export const resolveCameraGestureMode = (trackedPointerCount, nativeTouchCount) => {
  if (trackedPointerCount <= 0) {
    return CAMERA_GESTURE.NONE;
  }

  if (trackedPointerCount === 2 && nativeTouchCount >= 2) {
    return CAMERA_GESTURE.PINCH;
  }

  if (trackedPointerCount === 1 || nativeTouchCount === 1) {
    return CAMERA_GESTURE.PAN;
  }

  return CAMERA_GESTURE.NONE;
};
